import { addDisplayName, addProps, flowMax } from 'ad-hok'
import { FC } from 'react'
import { createUseStyles } from 'react-jss'

import rightChevron from 'assets/right-chevron.svg'
import { serifFontFamily } from 'utils/styles'
import { Link } from 'components/Link'

const useStyles = createUseStyles({
  container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    textDecoration: 'none',
    height: 44,
    paddingLeft: 6,
  },
  text: {
    fontFamily: serifFontFamily,
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: 16,
    lineHeight: '140%',
    letterSpacing: 0.4,
    color: 'rgba(255, 255, 255, 0.8)',
  },
  chevron: {
    opacity: 0.56,
  },
})

interface Props {
  text: string
  url: string
}

export const Row: FC<Props> = flowMax(
  addDisplayName('Row'),
  addProps(() => ({
    classes: useStyles(),
  })),
  ({ text, url, classes }) => (
    <Link url={url} className={classes.container}>
      <span className={classes.text}>{text}</span>
      <img src={rightChevron} alt="" className={classes.chevron} />
    </Link>
  )
)
